module.exports = __webpack_public_path__ + "img/chat_off.7341834f.svg";